import type { EmptyStateMobilePromoProps } from './components/EmptyStateMobilePromo';
import type * as lazyIndex from './lazyIndex';
import { LazyModule, createLazyComponent, type LazyComponent } from 'owa-bundling';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "GuidedSetupCards" */ './lazyIndex'),
    { name: 'GuidedSetupCards' }
);

export const EmptyStateMobilePromoComponent: LazyComponent<
    EmptyStateMobilePromoProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.EmptyStateMobilePromo);

export { OutlookMobileContainer } from './utils/OutlookMobileContainer';
